export default {
    typography: {
      fontFamily: [
        'Avenir',
        'Arial',
        'sans-serif',
      ].join(','),
      subtitle1:{
          fontSize:'0.8rem',
      }
    },
    palette:{
        common:{
            black:"rgba(0, 0, 0, 1)",
            white:"rgba(255, 255, 255, 1)"
        },
        background:{
            paper:"rgba(255,255,255, 1)",
            default:"rgba(34, 34, 34, 1)"
        },
        primary:{
            light:"rgba(240, 93, 93, 1)",
            main:"rgba(217, 0, 0, 1)",
            dark:"rgba(193, 0, 0, 1)",
            contrastText:"#fff"
        },
        secondary:{
            light:"rgba(217, 0, 0, 1)",
            main:"rgba(217, 0, 0, 1)",
            dark:"rgba(156, 0, 0, 1)",
            contrastText:"#fff"
        },
        error:{
            light:"#e57373",
            main:"#f44336",
            dark:"#d32f2f",
            contrastText:"#fff"
        },
        text:{
            primary:"rgba(0, 0, 0, 0.87)",
            secondary:"rgba(0, 0, 0, 0.54)",
            disabled:"rgba(233, 233, 233, 0.38)",
            hint:"rgba(247, 48, 48, 0.38)"
        }
    }
}
